module.exports = __webpack_public_path__ + "img/control-3@2x.4e219bf.jpg";